import { render, staticRenderFns } from "./MyCart.vue?vue&type=template&id=183be236"
import script from "./MyCart.vue?vue&type=script&lang=js"
export * from "./MyCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports